export default {
  id: 'ec6e4b032437475bb907d7a1c0074b48',
  name: 'Piotr Domagała',
  email: 'piotr.domagala@compensa.pl',
  passcode: '606I1PQRV9',
  logo_url: 'https://www.okchanger.com/cryptocurrency/preview-file/1712',
  bg_img_url:
    'https://images.unsplash.com/photo-1496151763167-abae6c394463?dpr=2&auto=format&fit=crop&w=1500&h=500&q=80&cs=tinysrgb&crop=',
  investment_focus: ['company'],
  country: 'BM',
  city: 'Ulan Bator',
  type: 'Angel',
  caption: 'Money grow, such investment, much profit, wow.',
  investment: '0-1K',
  stages: ['idea', 'pre_seed', 'seed', 'early_growth', 'growth', 'maturity'],
  rounds: ['SEED', 'SERIES_A', 'SERIES_B', 'OTHER'],
  business_type: ['B2B', 'B2C', 'B2G'],
  product_type: ['hardware', 'software'],
  countries: ['AX', 'AQ', 'BV', 'BQ', 'SJ'],
  sectors: [
    { value: 'ai', label: 'AI' },
    { value: 'art_and_design', label: 'Art & Design' },
    { value: 'automotive_and_transport', label: 'Automotive & Transport' },
    { value: 'biotechnology', label: 'Biotechnology' },
    { value: 'blockchain', label: 'Blockchain' },
    { value: 'chemistry', label: 'Chemistry ' },
    { value: 'cleantech', label: 'Cleantech' },
    {
      value: 'construction_and_manufacturing',
      label: 'Construction & Manufacturing',
    },
  ],
  website: 'www.google.com',
}
